"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phaethon = void 0;
const phaethonApi_1 = require("../../private/api-services/phaethonApi");
const env_1 = require("../../conf/env");
class Phaethon {
    constructor() {
        if (!env_1.PHAETHON_API_KEY) {
            throw new Error('cloud not found PHAETHON_API_KEY');
        }
        this.api = new phaethonApi_1.PhaethonApi(env_1.PHAETHON_API_KEY, false, false);
    }
    indexer(type, uuid) {
        return this.api.get(`index/${type}/${uuid}`);
    }
    delete(type, body) {
        return this.api.post(`index/delete-${type}`, body);
    }
}
exports.Phaethon = Phaethon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhhZXRob24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHVibGljL3NlcnZpY2VzL3BoYWV0aG9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHdFQUFxRTtBQUNyRSx3Q0FBa0Q7QUFHbEQsTUFBYSxRQUFRO0lBSW5CO1FBQ0UsSUFBSSxDQUFDLHNCQUFnQixFQUFFO1lBQ3JCLE1BQU0sSUFBSSxLQUFLLENBQUMsa0NBQWtDLENBQUMsQ0FBQTtTQUNwRDtRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSx5QkFBVyxDQUFNLHNCQUFnQixFQUFFLEtBQUssRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNsRSxDQUFDO0lBRU0sT0FBTyxDQUFDLElBQVksRUFBRSxJQUFXO1FBQ3RDLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsU0FBUyxJQUFJLElBQUksSUFBSSxFQUFFLENBQUMsQ0FBQTtJQUM5QyxDQUFDO0lBRU0sTUFBTSxDQUFDLElBQVksRUFBRSxJQUEwQjtRQUNwRCxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLGdCQUFnQixJQUFJLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0NBRUY7QUFwQkQsNEJBb0JDIn0=